import {Skeleton, Stack} from '@mui/material';

const ResidenceInformationSkeleton = () => {
    return (
        <>
            <div className="pt-20 centerClassMaxWith">
                <Stack spacing={2}>
                    <Skeleton variant="rounded" height={'120px'} />
                    <Skeleton variant="rounded" height={'50px'} />
                    <Skeleton variant="rounded" height={'50px'} />
                    <Skeleton variant="rounded" height={'83px'} />
                </Stack>
            </div>
        </>
    );
};

export default ResidenceInformationSkeleton;
